import { useEffect } from 'react'
import type { Dispatch } from 'react'
import { validateActivationToken } from '../../../customerAuthApi'
import type { ActivationFlowAction } from './ActivationFlow.types'

export type ActivationFlowQueryParams = {
  token: string
  recoveryEmail: string
}

export const readActivationFlowQueryParams = (search: string): ActivationFlowQueryParams => {
  const query = new URLSearchParams(search)
  const token = query.get('token')?.trim() ?? ''
  const recoveryEmail = query.get('email')?.trim() ?? query.get('mail')?.trim() ?? ''

  return {
    token,
    recoveryEmail,
  }
}

type UseActivationFlowEffectsInput = {
  dispatch: Dispatch<ActivationFlowAction>
}

export const useActivationFlowEffects = ({ dispatch }: UseActivationFlowEffectsInput) => {
  useEffect(() => {
    if (typeof window === 'undefined') return

    const { token, recoveryEmail } = readActivationFlowQueryParams(window.location.search)
    dispatch({
      type: 'INIT_FROM_QUERY',
      token,
      recoveryEmail,
    })

    if (!token) return

    let cancelled = false

    void validateActivationToken(token)
      .then((response) => {
        if (cancelled) return
        if (response.status === 'valid') {
          dispatch({ type: 'TOKEN_VALID' })
          return
        }

        if (response.status === 'expired') {
          dispatch({ type: 'TOKEN_EXPIRED' })
          return
        }

        dispatch({ type: 'TOKEN_INVALID' })
      })
      .catch(() => {
        if (cancelled) return
        dispatch({ type: 'TOKEN_VALIDATION_FAILED' })
      })

    return () => {
      cancelled = true
    }
  }, [dispatch])
}
